//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

//IMG
import sede1Img from "../../../public/assets/images/altrePag/sede1.jpg";
import sede2Img from "../../../public/assets/images/altrePag/sede2.jpg";
import agente1 from "../../../public/assets/images/altrePag/agente1.png";
import agente2 from "../../../public/assets/images/altrePag/agente2.png"

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    return(
        <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-6 order-lg-1 mb-4 mb-lg-5">
                <h2 className="mb-4">{t('aboutUsPage.title1')}</h2>
                <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
                <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
            </div>
            <div className="col-12 col-md-9 col-lg-6 order-lg-1 mb-4 mb-lg-5">
                <img src={sede1Img} className="img-fluid" alt={`${t('aboutUsPage.img1Alt')}`} />
                <img src={agente2} className="agent-img" alt={`${t('aboutUsPage.img2Alt')}`} />
            </div>
            <div className="col-12 col-lg-6 order-lg-4 mb-4 mb-lg-5">
                <h2 className="mb-4">{t('aboutUsPage.title2')}</h2>
                <p>{t('aboutUsPage.para3')}</p>
                <ul>
                    <li>{t('aboutUsPage.liElement1')}</li>
                    <li>{t('aboutUsPage.liElement2')}</li>
                    <li>{t('aboutUsPage.liElement3')}</li>
                    <li>{t('aboutUsPage.liElement4')}</li>
                    <li>{t('aboutUsPage.liElement5')}</li>
                </ul>
                <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }} />
            </div>
            <div className="col-12 col-md-9 col-lg-6 order-lg-3 mb-4 mb-lg-5">
                <img src={sede2Img} className="img-fluid" alt={`${t('aboutUsPage.img3Alt')}`} />
                <img src={agente1} className="agent-img" alt={`${t('aboutUsPage.img4Alt')}`} />
            </div>
        </div>
    )
};
export default AboutUsMain;